import React from "react";

function SettingsFive() {
  return <div>SettingsFive</div>;
}

export default SettingsFive;
